/**
 * Skills related api calls are kept here
 */

import axios, { baseRequestConfig } from './base';

export function initializeBrowseTasks(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'browse_init',
      },
    },
  });
}

export function getBrowseTaskSkills(userToken, value) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'browse_get_skills',
        values: {
          browse_id: value,
        },
      },
    },
  });
}

export function getBrowseTaskInterests(userToken, value) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'browse_get_interests',
        values: {
          browse_id: value,
        },
      },
    },
  });
}


export function browseTaskEdit(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'browse_edit',
        values: {
          ...values,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/browse_tasks.js